import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "a801dad0-19eb-4bc5-932a-80cff3cccf11", content: "mode (0,0,0)", options: {} },
  { id: "1adad1b0-4c68-4298-a56a-2ded43398323", content: "mode (1,0,0)", options: {} },
  { id: "add5d2f9-ef7b-4284-b399-596f7cbe77cd", content: "mode (0,1,0)", options: {} },
  { id: "08776710-258b-49e4-b3da-2560618b5cc4", content: "mode (0,0,1)", options: {} },
  { id: "39e3738e-8b53-4bdd-bef7-3645b4735dae", content: "mode (1,1,0)", options: {} },
  { id: "3be741fd-aa4e-41b0-88f4-fdf9e35195f8", content: "mode (1,0,1)", options: {} },
  { id: "5452ea87-999d-4751-8e72-cf3168849ea3", content: "mode (1,1,1)", options: {} },
  { id: "9229b7b6-4229-412f-a8e3-d35016245fb8", content: "mode (2,0,0)", options: {} },
  { id: "1bae1915-974b-42ce-902a-cdc4a6af0427", content: "mode (2,0,1)", options: {} },
  { id: "c8b0746d-0285-4bbb-a686-93fc6bf0b88b", content: "mode (3,0,0)", options: {} },
];

const groups = [
  { id: "2bcedbc1-e854-4656-94b0-0b120569da9c", content: "0 Hz", options: {} },
  { id: "f83dd559-663c-46c4-b95c-aa495c1f868e", content: "17 Hz", options: {} },
  { id: "a9ed174b-064b-4b19-a1a5-e9c0593bc7e2", content: "24 Hz", options: {} },
  { id: "ee866b06-db01-4781-87c4-07039b36ea93", content: "30 Hz", options: {} },
  { id: "88b8baef-1389-4df1-885e-f1b85b7b3136", content: "34 Hz", options: {} },
  { id: "03a37737-823e-4719-8713-79d30c219cac", content: "51 Hz", options: {} },
  { id: "57991bbf-53a5-457c-a80b-cec0e37635e6", content: "57 Hz", options: {} },
  { id: "31322827-4591-4e0d-963b-e00b0d0490d5", content: "59 Hz", options: {} },
  { id: "583dc5c0-79f9-4c0a-81ba-c92471eb8050", content: "64 Hz", options: {} },
  { id: "89b6f65b-a6ea-415d-82b3-aec0197e4399", content: "66 Hz", options: {} },
];

export const task: Task = {
  id: "89256825-674b-48a2-a909-11289f46e62a",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    orientation: "horizontal",
    shuffle: false,
    multipleConnection: false,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    { groupId: "2bcedbc1-e854-4656-94b0-0b120569da9c", itemsId: ["a801dad0-19eb-4bc5-932a-80cff3cccf11"] },
    { groupId: "f83dd559-663c-46c4-b95c-aa495c1f868e", itemsId: ["1adad1b0-4c68-4298-a56a-2ded43398323"] },
    { groupId: "a9ed174b-064b-4b19-a1a5-e9c0593bc7e2", itemsId: ["add5d2f9-ef7b-4284-b399-596f7cbe77cd"] },
    { groupId: "ee866b06-db01-4781-87c4-07039b36ea93", itemsId: ["39e3738e-8b53-4bdd-bef7-3645b4735dae"] },
    { groupId: "88b8baef-1389-4df1-885e-f1b85b7b3136", itemsId: ["9229b7b6-4229-412f-a8e3-d35016245fb8"] },
    { groupId: "03a37737-823e-4719-8713-79d30c219cac", itemsId: ["c8b0746d-0285-4bbb-a686-93fc6bf0b88b"] },
    { groupId: "57991bbf-53a5-457c-a80b-cec0e37635e6", itemsId: ["08776710-258b-49e4-b3da-2560618b5cc4"] },
    { groupId: "31322827-4591-4e0d-963b-e00b0d0490d5", itemsId: ["3be741fd-aa4e-41b0-88f4-fdf9e35195f8"] },
    { groupId: "583dc5c0-79f9-4c0a-81ba-c92471eb8050", itemsId: ["5452ea87-999d-4751-8e72-cf3168849ea3"] },
    { groupId: "89b6f65b-a6ea-415d-82b3-aec0197e4399", itemsId: ["1bae1915-974b-42ce-902a-cdc4a6af0427"] },
  ],
};
